module.exports = __webpack_public_path__ + "user-template.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-template.xlsx
// module id = 568
// module chunks = 1